import { AllDownloadsPayload } from "@shared/SPA/UWPNotifier"

const CONVERT_TO_PERCENT = 100

export const getPlaybackProgress = (progress?: number) =>
  progress ? Math.round(progress * 100) : 0

export const getAppPlaybackProgress = (downloads: AllDownloadsPayload, playbackTitleId: string, duration: number) => {
  const download = downloads && downloads[playbackTitleId]
  // Duration is in seconds and needs to be converted to milliseconds
  const resumeTime = download && download.ResumeTime
  return ((resumeTime === 0) ? 100 :
    (duration && resumeTime > 0 ? (CONVERT_TO_PERCENT * resumeTime / (duration * 1000)) : 0)) || 0
}

export const isWatched = (progress?: number) => progress === 1
